import { EPaymentMethod } from "../../../../../../../../dependencies/getContent/constants";
import { produce } from "../../../../../../../../../libs/immer";
import { withProcessingLogic } from "../../../../../../../../utils/utils.domain";
import { submitSberPayUseCase } from "../../Button/logic/submitSberPay.case";
// dependency injected factory function for sberpay captcha input props
export var getMapStateToSberPayCaptchaInputProps = function getMapStateToSberPayCaptchaInputProps(_ref) {
  var getContent = _ref.getContent,
    submitSberPayPayment = _ref.submitSberPayPayment,
    getCaptchaImage = _ref.getCaptchaImage,
    refreshCaptcha = _ref.refreshCaptcha;
  return function (getState, setState) {
    var _state$scenario, _state$scenario$captc, _state$scenario$captc2;
    var state = getState();
    if (((_state$scenario = state.scenario) === null || _state$scenario === void 0 ? void 0 : _state$scenario.type) !== EPaymentMethod.SberPay) throw new Error('not sberpay screen');
    var _getContent = getContent(),
      captchaText = _getContent.sberPayPopup.captcha;
    var _getCaptchaImage = getCaptchaImage(),
      image = _getCaptchaImage.image,
      key = _getCaptchaImage.key;
    return state.scenario.step === 1 ? {
      onMount: function onMount() {
        withProcessingLogic(setState)(refreshCaptcha()).catch(console.error);
      },
      onRefresh: function onRefresh() {
        withProcessingLogic(setState)(refreshCaptcha()).catch(console.error);
      },
      captchaKey: key,
      pic: image,
      inputProps: {
        value: (_state$scenario$captc = state.scenario.captchaInput) === null || _state$scenario$captc === void 0 ? void 0 : _state$scenario$captc.value,
        error: (_state$scenario$captc2 = state.scenario.captchaInput) === null || _state$scenario$captc2 === void 0 ? void 0 : _state$scenario$captc2.errorMessage,
        label: captchaText.label,
        placeholder: captchaText.placeholder,
        onBlur: function onBlur() {},
        onClick: function onClick() {},
        onEnter: function onEnter() {
          submitSberPayUseCase({
            submitSberPayPayment: submitSberPayPayment,
            getContent: getContent,
            refreshCaptcha: refreshCaptcha
          })(getState, setState).catch(console.error);
        },
        onChange: function onChange(value) {
          setState(produce(function (draft) {
            var _draft$scenario, _draft$scenario2;
            if (((_draft$scenario = draft.scenario) === null || _draft$scenario === void 0 ? void 0 : _draft$scenario.type) === EPaymentMethod.SberPay && (_draft$scenario2 = draft.scenario) !== null && _draft$scenario2 !== void 0 && _draft$scenario2.captchaInput) {
              draft.scenario.captchaInput.errorMessage = undefined;
              draft.scenario.captchaInput.value = value !== null && value !== void 0 ? value : '';
            }
          }));
        }
      }
    } : undefined;
  };
};